import { observable } from "mobx";
import Validatable from "../common/Validatable";

export default abstract class TaskSubData extends Validatable {
    @observable type?: string;

}
